import { CalculationRowUnit, CalcRowConfig, CalculationRowCategory, CalcRowConfigNumberInput } from "../../model";
import { Years } from "../../util/Years";

/**
 * Calculation rows configuration: categories, UI elements etc.
 * The texts are stored in translations.
 */
export const calcRowsMetadata: Partial<CalcRowConfig>[] = [
  {
    order: 1,
    name: "salary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [227]
  },
  {
    order: 2,
    name: "hourlySalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3,
    name: "monthlySalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [201]
  },
  {
    order: 8,
    name: "timeRatePay",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: { unit: CalculationRowUnit.Hours, units: [CalculationRowUnit.Hours, CalculationRowUnit.Days, CalculationRowUnit.Weeks, CalculationRowUnit.Months] },
    kind: { name: "TimeRatePayKind", values: null },
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 4,
    name: "compensation",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [336]
  },
  {
    order: 5,
    name: "totalWorkerPayment",
    category: CalculationRowCategory.SalaryCalc,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
  },
  {
    order: 6,
    name: "totalEmployerPayment",
    category: CalculationRowCategory.SalaryCalc,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
  },
  {
    order: 7,
    name: "board",
    category: CalculationRowCategory.Salary,
    kind: { name: "BoardKind", values: null },
    color: "#4a92e9",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [308]
  },
  {
    order: 9,
    name: "hourlySalaryWithWorkingTimeCompensation",
    category: CalculationRowCategory.SalaryAdditions,
    kind: { name: "WorkingTimeCompensationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
  },
  {
    order: 10,
    name: "overtime",
    category: CalculationRowCategory.SalaryAdditions,
    color: "#15535d",
    amount: {
      default: 0.5,
      unit: CalculationRowUnit.Percent,
    },
    total: {},
    price: {},
    incomeTypes: [235]
  },
  {
    order: 11,
    name: "tesWorktimeShortening",
    category: CalculationRowCategory.SalaryAdditions,
    color: "#15535d",
    favorite: 90,
    amount: {
      default: 0.077,
      unit: CalculationRowUnit.Percent,
    },
    total: {},
    price: {},
    incomeTypes: [216]
  },
  {
    order: 12,
    name: "eveningAddition",
    category: CalculationRowCategory.SalaryAdditions,
    color: "#15535d",
    amount: {
      unit: CalculationRowUnit.Hours,
    },
    total: {},
    price: {},
    incomeTypes: [206]
  },
  {
    order: 13,
    name: "nightimeAddition",
    category: CalculationRowCategory.SalaryAdditions,
    color: "#15535d",
    amount: {
      unit: CalculationRowUnit.Hours,
    },
    total: {},
    price: {},
    incomeTypes: [236]
  },
  {
    order: 14,
    name: "saturdayAddition",
    category: CalculationRowCategory.SalaryAdditions,
    color: "#15535d",
    amount: {
      default: 0.5,
      unit: CalculationRowUnit.Percent,
    },
    total: {},
    price: {},
    incomeTypes: [211]
  },
  {
    order: 15,
    name: "sundayWork",
    category: CalculationRowCategory.SalaryAdditions,
    color: "#15535d",
    favorite: 10,
    amount: {},
    total: {},
    price: {},
    incomeTypes: [221]
  },
  {
    order: 19,
    name: "otherAdditions",
    category: CalculationRowCategory.SalaryAdditions,
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [216]
  },
  {
    order: 20,
    name: "remuneration",
    category: CalculationRowCategory.SalaryAdditions,
    kind: { name: "RemunerationKind", values: null },
    color: "#15535d",
    amount: { default: 1, unit: CalculationRowUnit.Percent, units: [CalculationRowUnit.Percent, CalculationRowUnit.Count]},
    total: {},
    price: {},
    incomeTypes: [202, 203, 220, 223, 226, 233]
  },
  {
    order: 21,
    name: "otherCompensation",
    category: CalculationRowCategory.SalaryAdditions,
    kind: { name: "OtherCompensationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [210, 214, 215, 225, 308, 310, 313, 314, 316, 320, 326, 332, 339, 340, 343, 361, 366, 367, 368]
  },
  {
    order: 22,
    name: "workingTimeCompensation",
    category: CalculationRowCategory.SalaryAdditions,
    kind: { name: "WorkingTimeCompensationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes:[205, 206, 207, 211, 212, 216, 217, 221, 230, 232, 235, 236, 237]
  },
  {
    order: 23,
    name: "employmentTermination",
    category: CalculationRowCategory.SalaryAdditions,
    kind: { name: "EmploymentTerminationKind", values: null },
    color: "#15535d",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [208, 224, 229, 231, 338]
  },
  {
    order: 101,
    name: "accomodationBenefit",
    category: CalculationRowCategory.Benefits,
    color: "#4fcdc4",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [301]
  },
  {
    order: 102,
    name: "mealBenefit",
    category: CalculationRowCategory.Benefits,
    kind: { name: "MealBenefitKind", values: null }, // TODO: Add support for marking kinds/rowTypes as obsolete (must be invisible in searches but supported older calculations)
    color: "#4fcdc4",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [303, 334, 407, 408]
  },
  {
    order: 103,
    name: "phoneBenefit",
    category: CalculationRowCategory.Benefits,
    color: "#4fcdc4",
    amount: { default: 1 },
    price: { default: 20 },
    total: {},
    incomeTypes: [330]
  },
  {
    order: 104,
    name: "carBenefit",
    category: CalculationRowCategory.Benefits,
    kind: { name: "CarBenefitKind", values: null },
    color: "#4fcdc4",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: {},
    price: {},
    incomeTypes: [304, 401]
  },
  {
    order: 105,
    name: "bicycleBenefit",
    category: CalculationRowCategory.Benefits,
    kind: { name: "BicycleBenefitKind", values: null },
    color: "#4fcdc4",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: {},
    price: {},
    incomeTypes: [363, 364, 420]
  },
  {
    order: 199,
    name: "otherBenefit",
    category: CalculationRowCategory.Benefits,
    color: "#4fcdc4",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [317]
  },
  {
    order: 201,
    name: "holidayCompensation",
    category: CalculationRowCategory.Holidays,
    color: "#ffe66d",
    favorite: 80,
    amount: {
      default: 0.115,
      unit: CalculationRowUnit.Percent, units: [CalculationRowUnit.Percent, CalculationRowUnit.Count],
    },
    total: {},
    price: {},
    incomeTypes: [234]
  },
  {
    order: 202,
    name: "holidayBonus",
    category: CalculationRowCategory.Holidays,
    color: "#ffe66d",
    amount: {
      unit: CalculationRowUnit.Percent, units: [CalculationRowUnit.Percent, CalculationRowUnit.Count],
    },
    total: {},
    price: {},
    incomeTypes: [213]
  },
  {
    order: 203,
    name: "holidaySalary",
    category: CalculationRowCategory.Holidays,
    color: "#ffe66d",
    amount: {
      default: 1,
      unit: CalculationRowUnit.Count
    },
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 301,
    name: "dailyAllowance",
    category: CalculationRowCategory.Expenses,
    kind: { name: "DailyAllowanceKind", values: null },
    color: "#ffa900",
    favorite: 100,
    price: { default: Years.getYearlyChangingNumbers(new Date(), true)?.sideCosts?.taxFreeDailyAllowance },
    amount: {},
    total: {},
    incomeTypes: [331]
  },
  {
    order: 302,
    name: "dailyAllowanceHalf",
    category: CalculationRowCategory.Expenses,
    color: "#ffa900",
    price: { default: Years.getYearlyChangingNumbers(new Date(), true)?.sideCosts?.taxFreeDailyHalfAllowance },
    amount: { unit: CalculationRowUnit.Days },
    total: {},
    incomeTypes: [331]

  },
  {
    order: 303,
    name: "mealCompensation",
    category: CalculationRowCategory.Expenses,
    color: "#ffa900",
    price: { default: Years.getYearlyChangingNumbers(new Date(), true)?.sideCosts?.taxFreeMealAllowance },
    amount: { unit: CalculationRowUnit.Days },
    total: {},
    incomeTypes: [303]
  },
  {
    order: 304,
    name: "milageOwnCar",
    category: CalculationRowCategory.Expenses,
    color: "#ffa900",
    favorite: 20,
    price: { default: Years.getYearlyChangingNumbers(new Date(), true)?.sideCosts?.taxFreeKmAllowance },
    amount: { unit: CalculationRowUnit.Kilometers },
    total: {},
    incomeTypes: [311]
  },
  {
    order: 305,
    name: "toolCompensation",
    category: CalculationRowCategory.Expenses,
    color: "#ffa900",
    favorite: 60,
    amount: { unit: CalculationRowUnit.Days },
    total: {},
    price: {},
    incomeTypes: [353]
  },
  {
    order: 306,
    name: "expenses",
    category: CalculationRowCategory.Expenses,
    color: "#ffa900",
    favorite: 70,
    amount: {},
    total: {},
    price: {},
    incomeTypes: [1]
  },
  {
    order: 307,
    name: "milageDaily",
    category: CalculationRowCategory.Expenses,
    color: "#ffa900",
    favorite: 30,
    amount: { unit: CalculationRowUnit.Days },
    total: {},
    price: {},
    incomeTypes: [311]
  },
  {
    order: 308,
    name: "milageOther",
    category: CalculationRowCategory.Expenses,
    color: "#ffa900",
    amount: { unit: CalculationRowUnit.Days },
    total: {},
    price: {},
    incomeTypes: [311]
  },
  {
    order: 401,
    name: "unionPayment",
    category: CalculationRowCategory.Deductions,
    kind: { name: "UnionPaymentKind", values: null },
    color: "#ff6738",
    amount: { input: CalcRowConfigNumberInput.Hidden },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: { input: CalcRowConfigNumberInput.Hidden },
    incomeTypes: [408]
  },
  {
    order: 402,
    name: "foreclosure",
    category: CalculationRowCategory.Deductions,
    kind: { name: "ForeclosureKind", values: null },
    color: "#ff6738",
    amount: { input: CalcRowConfigNumberInput.Hidden },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: { input: CalcRowConfigNumberInput.Hidden },
    incomeTypes: [417]
  },
  {
    order: 403,
    name: "advance",
    category: CalculationRowCategory.Deductions,
    color: "#ff6738",
    favorite: 40,
    amount: { input: CalcRowConfigNumberInput.Hidden },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [1]
  },
  {
    order: 405,
    name: "prepaidExpenses",
    category: CalculationRowCategory.Deductions,
    color: "#ff6738",
    amount: { input: CalcRowConfigNumberInput.Hidden },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [1]
  },
  {
    order: 406,
    name: "otherDeductions",
    category: CalculationRowCategory.Deductions,
    color: "#ff6738",
    amount: { input: CalcRowConfigNumberInput.Hidden },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [408]
  },
  {
    order: 407,
    name: "deductibleOfExerciseAndCultureBenefit",
    category: CalculationRowCategory.Deductions,
    color: "#ff6738",
    amount: { input: CalcRowConfigNumberInput.Hidden },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [408]
  },
  {
    order: 500,
    name: "taxAtSource",
    category: CalculationRowCategory.Deductions,
    kind: { name: "TaxAtSourceKind", values: null },
    color: "#ff6738",
    amount: {
      unit: CalculationRowUnit.Percent,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: {},
    price: {
      input: CalcRowConfigNumberInput.Hidden,
    },
    incomeTypes: [404, 405, 412]
  },
  {
    order: 501,
    name: "taxWithholding",
    category: CalculationRowCategory.Deductions,
    kind: { name: "TaxWithholdingKind", values: null },
    color: "#ff6738",
    amount: {
      unit: CalculationRowUnit.Percent,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: {},
    price: {
      input: CalcRowConfigNumberInput.Hidden,
    },
    incomeTypes: [402]
  },
  {
    order: 505,
    name: "absencePeriod",
    category: CalculationRowCategory.Deductions,
    kind: { name: "AbsenceCauseCode", values: null },
    color: "#ff6738",
    amount: {},
    total: {},
    price: {
      input: CalcRowConfigNumberInput.Hidden,
    },
    incomeTypes: []
  },
  {
    order: 901,
    name: "childCareSubsidy",
    category: CalculationRowCategory.Deductions,
    color: "#4fcdc4",
    favorite: 50,
    amount: { input: CalcRowConfigNumberInput.Hidden },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [321]
  },
  {
    order: 1010,
    name: "nonProfitOrg",
    category: CalculationRowCategory.Expenses,
    kind: { name: "NonProfitOrgKind", values: null },
    color: "#ffa900",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [357,358]
  },
  {
    order: 1020,
    name: "subsidisedCommute",
    category: CalculationRowCategory.Benefits,
    kind: { name: "SubsidisedCommuteKind", values: null },
    color: "#4fcdc4",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: {},
    price: {},
    incomeTypes: [341,342,415]
  },
  {
    order: 1100,
    name: "paidSickLeave",
    category: CalculationRowCategory.Salary,
    kind: { name: "PaidSickLeaveKind", values: null },
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201,227]
  },
  {
    order: 1110,
    name: "training",
    category: CalculationRowCategory.Salary,
    kind: { name: "TrainingKind", values: null },
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201,227]
  },
  {
    order: 3001,
    name: "paidSickLeaveSalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [227]
  },
  {
    order: 3002,
    name: "paidSickLeaveHourlySalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3003,
    name: "paidSickLeaveMonthlySalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3004,
    name: "trainingSalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [227]
  },
  {
    order: 3005,
    name: "trainingHourlySalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [201]
  },
  {
    order: 3003,
    name: "trainingMonthlySalary",
    category: CalculationRowCategory.Salary,
    color: "#4a92e9",
    amount: {
      default: 1,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {},
    incomeTypes: [201]
  },
  {
    order: 9999,
    name: "irIncomeType",
    category: CalculationRowCategory.Salary,
    kind: { name: "TransactionCode", values: null },
    color: "#4a92e9",
    amount: { default: 1 },
    total: {},
    price: {},
  },
  {
    order: 10000,
    name: "script",
    category: CalculationRowCategory.Other,
    color: "#f7df1e",
    amount: {
      default: 0,
      input: CalcRowConfigNumberInput.Hidden,
    },
    total: { input: CalcRowConfigNumberInput.Hidden },
    price: {
      default: 0,
      input: CalcRowConfigNumberInput.Hidden
    },
  },
  {
    order: 10001,
    name: "serviceCharge",
    category: CalculationRowCategory.Other,
    color: "#289548",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [1]
  },
  {
    order: 10002,
    name: "service",
    category: CalculationRowCategory.Other,
    color: "#289548",
    amount: { default: 1 },
    total: {},
    price: {},
    incomeTypes: [1]
  },
  {
    order: 10003,
    name: "payStats",
    category: CalculationRowCategory.Other,
    kind: { name: "PayStatsKind", values: null },
    color: "#289548",
    amount: {},
    total: {},
    price: {},
    incomeTypes: [1]
  }
];
